import cx from 'classnames';
import { Grid } from 'semantic-ui-react';
import React from 'react';

const View = (props) => {
  const { className, style } = props;
  return (
    <div className={cx('block', 'renew', className)} style={style}>
      <div className="block-container">
        <Grid stackable centered>
          <form
            action="https://www.paypal.com/cgi-bin/webscr"
            method="post"
            target="_top"
          >
            <input type="hidden" name="cmd" value="_s-xclick" />
            <input
              type="hidden"
              name="hosted_button_id"
              value="DMUJD64MWJTSA"
            />
            <table>
              <tr>
                <td>
                  <input
                    type="hidden"
                    required
                    name="on0"
                    value="Portknox Account Name"
                  />
                  Portknox Account Name
                </td>
              </tr>
              <tr>
                <td>
                  <input type="text" name="os0" maxLength="200" />
                </td>
              </tr>
            </table>
            <input
              type="image"
              src="https://www.paypalobjects.com/de_DE/DE/i/btn/btn_paynowCC_LG.gif"
              border="0"
              name="submit"
              alt="Jetzt einfach, schnell und sicher online bezahlen – mit PayPal."
            />
            <img
              alt=""
              border="0"
              src="https://www.paypalobjects.com/de_DE/i/scr/pixel.gif"
              width="1"
              height="1"
            />
          </form>
        </Grid>
      </div>
    </div>
  );
};

export default View;
